import { getSupabase, unwrap } from "./supabaseClient";

export interface HistoryEvent {
  id: number;
  intervention_id: string;
  created_at: string;
  actor_email: string | null;
  action: "created" | "updated" | "status" | "deleted" | "custom_field" | "comment" | "questionnaire";
  source: string;
  changes: Record<string, { old?: unknown; new?: unknown; changed?: boolean; old_length?: number; new_length?: number }>;
}

/** Only invoked when an admin expands history. Supabase RLS scopes the results. */
export async function fetchInterventionHistory(
  interventionId: string,
  limit = 20,
): Promise<HistoryEvent[]> {
  return unwrap(
    await getSupabase()
      .from("intervention_history")
      .select("id, intervention_id, created_at, actor_email, action, source, changes")
      .eq("intervention_id", interventionId)
      .order("created_at", { ascending: false })
      .order("id", { ascending: false })
      .limit(limit),
  ) as HistoryEvent[];
}
